import {get, post, setTokenData} from "../APIGateWay";

export async function authLogin(params) {
    const res = await post(params, '/connect/token')
    const data = res.data.results
    setTokenData(
        data.access_token,
        data.refresh_token,
        data.expires_in
    )
    return res
}   

export async function authLogout() {
    return await get({}, '/user/logout')
}

export async function authRegister(params) {
    const res = await post(params, '/user/register')
    const data = res.data.results
    setTokenData(
        data.access_token,
        data.refresh_token,
        data.expires_in
    )
    return res
}

export async function authRegisterParent(params) {
    return "developing"
}

export async function authAnonymous(params) {
    return await post(params, '/user/change-info-password')
}

export async function authRegisterAnomynous(params) {
    const res = await post(params, '/user/register/anonymous')
    const data = res.data.results
    setTokenData(
        data.access_token,
        data.refresh_token,
        data.expires_in
    )
    return res
}

export async function getForgetAccount(params) {
    return await get(params, '/forget-account/show')
}

export async function getListForgetAccount(params) {
    return await get(params, '/forget-account/list')
}

export async function confirmForget(params) {
    return await post(params, '/forget-account/confirm-forget')
}

export async function confirmOtp(params) {
    return await post(params, '/forget-account/confirm-otp')
}

export async function resetPassword(params) {
    return await post(params, '/forget-account/reset-new-pass')
}

export  async function changeNewPassword(params) {
    return await post(params, '/user/change-new-pass')
}




